import { SmileOutlined } from "@ant-design/icons";
import { EMOJIS_CHAT } from "./chatEmojis";

export const ChatEmojiPicker = ({ aberto, onAlternar, onEscolher }) => {
  return (
    <div className="chat-emoji">
      {aberto && (
        <div className="chat-emoji-painel" role="listbox" aria-label="Emojis">
          {EMOJIS_CHAT.map((emoji) => (
            <button
              type="button"
              key={emoji}
              className="chat-emoji-item"
              onClick={() => onEscolher(emoji)}
              aria-label={`Inserir ${emoji}`}
            >
              {emoji}
            </button>
          ))}
        </div>
      )}
      <button
        type="button"
        className={`chat-composer__emoji${aberto ? " is-aberto" : ""}`}
        onClick={onAlternar}
        aria-label="Inserir emoji"
        aria-expanded={aberto}
        title="Emoji"
      >
        <SmileOutlined />
      </button>
    </div>
  );
};
